import request from '@/utils/request'

// 分页查询产品类别数据
export function getProductClassify(data) {
  return request({
    url: '/system/product/category/findAll',
    method: 'post',
    data
  })
}

// 查询规格信息
export function getSpecification(params) {
  return request({
    url: '/system/product/category/getSpecification',
    method: 'get',
    params
  })
}

// 修改规格信息
export function updateSpecification(data) {
  return request({
    url: '/system/product/category/updateSpecification',
    method: 'post',
    data
  })
}

// 查询基本信息
export function getBasicInfo(params) {
  return request({
    url: '/system/product/category/getBasicInfo',
    method: 'get',
    params
  })
}

// 修改基本信息
export function updateBasicInfo(data) {
  return request({
    url: '/system/product/category/updateBasicInfo',
    method: 'post',
    data
  })
}

// 新增基本信息
export function addBasicInfo(data) {
  return request({
    url: '/system/product/category/addBasicInfo',
    method: 'post',
    data
  })
}

// 删除
export function deleteCategory(data) {
  return request({
    url: '/system/product/category/deleteByIds',
    method: 'post',
    data
  })
}
// 查询产品类别关联实体信息
export function getAssociationInfo(params) {
  return request({
    url: '/system/product/category/getAssociationInfo',
    method: 'get',
    params
  })
}

// 修改实体关联信息
export function updateAssociationInfo(data) {
  return request({
    url: '/system/product/category/updateAssociationInfo',
    method: 'post',
    data
  })
}

export function selectBehaviorLabelByName(data) {
  return request({
    url: '/system/companyBehaviorLabel/selectBehaviorLabelByName',
    method: 'post',
    data
  })
}

export function importData(data) {
  return request({
    url: '/system/product/category/importData',
    method: 'post',
    data
  })
}
